module.exports = __webpack_public_path__ + "img/login-v2-dark.5932ff30.svg";